import axios from "./axios";
import { TagIF, ImageIF, CommentIF } from "../types";
import { resolve } from "path";

interface ContentResponse {
  id: number,
  title: string,
  post: string,
  summary: string,
  createdAt: string,
  tags: string[];
  images: ImageIF[];
}

interface CommentResponse {
    isAdmin: boolean,
    comment: string,
    date: string,
    LikeCnt: number,
    id: number
}

// interface LikeResponse {
//     content_id:number,
//     comment_id: number
// }

// 새 콘텐츠 생성 ~ 서버에 전송
export const newContent = async(
    id:number, 
    title: string, 
    post: string, 
    summary: string, 
    createdAt: string, 
    tags: TagIF[],
    images: ImageIF[]) : Promise<ContentResponse> => {
        // FormData Obj가 아니라면 브라우저는 내부의 File Obj들을 제대로 패키징 못함!
        // file or string 만 전달할 수 있음
        const formData = new FormData();

        formData.append("id", id.toString());
        formData.append("title", title);
        formData.append("post", post);
        formData.append("summary", summary);
        formData.append("createdAt", createdAt);
        formData.append("tags", JSON.stringify(tags));

        // POST 내 img 서버 주소 갱신을 위한 blobURL append
        const imagePreviews = images.map(img => img.preview);
        formData.append("previews", JSON.stringify(imagePreviews));
        
        images.forEach((imgObj) => {
            if (imgObj.file) {
                formData.append("images", imgObj.file);
            }
        });

        const response = await axios.post("/contents/contents", formData, { 
            headers: {
            "Content-Type": "multipart/form-data" // HTTP 통신에선 파일 전송 시 해당 타입으로 전송해야 함!
        }});
        
        return response.data;
};

/* --------------------------------------comment---------------------------------------------- */

// 콘텐츠에 댓글 추가
export const addComment = async(
    content_id: number,
    isAdmin: boolean,
    comment: string,
    date: string,
    LikeCnt: number,
    id: number) : Promise<CommentResponse> => {

        const response = await axios.put("/contents/addComment",
            {
                content_id,
                isAdmin,
                comment,
                date,
                LikeCnt,
                id
            });

        return response.data;
}

// 댓글 좋아요 수 갱신
export const increaseCommentLike = async(
    content_id: number,
    comment_id: number) => {
        await axios.put("/contents/increaseCommentLike", {content_id, comment_id});
}

// content 조회수 갱신
export const increaseView = async(
    content_id: number) => {
        await axios.put(`/contents/${content_id}/view`);
}

// content 하트수 갱신
export const increaseHeart = async(
    content_id:number) => {
        await axios.put(`/contents/${content_id}/heart`);
}

// content 수정
export const modifyContent = async(
    content_id: number,
    title: string, 
    post: string, 
    summary: string, 
    createdAt: string, 
    tags: TagIF[],
    images: ImageIF[]) : Promise<ContentResponse> => {
    
    const formData = new FormData();

    formData.append("id", content_id.toString());
    formData.append("title", title);
    formData.append("post", post);
    formData.append("summary", summary);
    formData.append("createdAt", createdAt);
    formData.append("tags", JSON.stringify(tags));

    // 1. 모든 이미지의 preview(경로 혹은 blobURL)를 보냅니다.
    const imagePreviews = images.map(img => img.preview);
    formData.append("previews", JSON.stringify(imagePreviews));

    // 2. 중요: 'File' 객체가 있는 것(새로 추가된 사진)만 실제 파일로 전송합니다.
    images.forEach((imgObj) => {
        if (imgObj.file instanceof File) {
            formData.append("images", imgObj.file);
        }
    });

    const response = await axios.put(`${process.env.REACT_APP_API_URL}/contents/modify/${content_id}`, formData, { 
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    
    return response.data;
}

// content 삭제
export const deleteContent = async(content_id: number) => {
    const response = axios.delete("/contents/delete", {data: {content_id}});
    return response;
};
